export default "__VITE_ASSET__ChZpSyFS__"